import { scrollLock } from './util';
import {
    KEYBOARD_KEYS,
    handleEscapeKey,
    trapModalFocus,
    removeModalFocus,
    saveFocus,
    restoreFocus,
} from './a11yHelper';

/**
 * Triggers open/closed state of modals
 * @param {string} element - modal element
 * @param {string} state - open or close
 * @param {string} ani - animation; up-down or nothing (for now)
 * @param {string} bodyModalCLass - class added to the body to show hide a particular backdrop if needed
*/

function modalTrigger(element, state, ani, bodyModalCLass = 'modal-overlay', preserveScrollLock = false) {
    if ($(element).length === 0) {
        return;
    }

    // before hide or show add or remove animation props
    if (ani === 'up-down') {
        $(element).addClass('fade-up-down');
    } else {
        $(element).removeClass('fade-up-down');
    }

    if (ani === 'from-side') {
        $(element).addClass('from-side');
    } else {
        $(element).removeClass('from-side');
    }

    if (ani === 'fade') {
        $(element).addClass('fade');
    } else {
        $(element).removeClass('fade');
    }

    setTimeout(() => {
        // If the modal is being opened, set trap focus
        if (state === 'open') {
            $(element).css('display', 'flex');
            $('body').addClass(bodyModalCLass);

            setTimeout(() => {
                $(element).addClass('show');
                if (!preserveScrollLock) scrollLock('on');
            }, 100);
        } else if (state === 'close') {
            $(element).removeClass('show');
            $('body').removeClass(bodyModalCLass);

            setTimeout(() => {
                $(element).css('display', 'none');
                $(element).removeClass('fade-up-down');
                if (!preserveScrollLock) scrollLock('off');
            }, 500);
        }
    }, 50);
}

/**
 * Checks if Item is in view
 * @param {string} ele - any element
 * @returns {boolean} - true if the element is in the viewport, otherwise false
 */
function isInViewport(ele) {
    const { top, bottom } = ele.getBoundingClientRect();
    const vHeight = (window.innerHeight || document.documentElement.clientHeight);

    if ((top > 0 || bottom > 0) && top < vHeight) {
        return true;
    }
    return false;
}

/**
 * Auto Triggers open state of modal after leadGenWinModalTimer when subscription boxes are not in viewport
 * @param {string} element - modal element
 * @param {string} ani - up-down or nothing
*/

function modalAutoOpen(element, ani) {
    if ($(element).length === 0) {
        return;
    }

    if (!window.sessionStorage.getItem('winModalSeen')) {
        window.sessionStorage.setItem('winModalSeen', 'no');
    }

    let timerFinished = false;
    const time = parseInt($('#winModalTime').val(), 10) * 1000;

    // Save the last focused element before modal opens
    // so we can return focus to it after modal is closed
    let lastFocusedElementBeforeModal;

    // Restore scroll position and focus after modal is closed
    function closeModalAndRestoreFocus() {
        modalTrigger(element, 'close', ani);
        window.sessionStorage.setItem('winModalSeen', 'yes');

        if (lastFocusedElementBeforeModal) {
            lastFocusedElementBeforeModal.focus();
        }
    }

    function showModal() {
        const sub1 = document.querySelector('.js-lead-gen-subscription-wrapper.subscription-1');
        const sub2 = document.querySelector('.js-lead-gen-subscription-wrapper.subscription-2');
        const modalsOpen = document.querySelector('body.modal-overlay');
        const winModalSeen = window.sessionStorage.getItem('winModalSeen');

        lastFocusedElementBeforeModal = document.activeElement;

        if (!isInViewport(sub1) && !isInViewport(sub2) && modalsOpen === null && timerFinished && winModalSeen === 'no') {
            saveFocus(); // Save the currently focused element

            // open modal
            modalTrigger(element, 'open', ani);

            // Make modal focusable
            (element).removeAttr('inert');

            // Give the DOM a moment to render the modal (important if it's display: none before)
            setTimeout(() => {
                const $modal = $('.js-subscription-win-modal'); // Or use a more specific selector if needed
                trapModalFocus($modal);
            }, 300); // Delay to ensure modal content is in DOM

            // set session
            $('.js-modal-close, .js-modal-backdrop').on('click', closeModalAndRestoreFocus);
        }
    }

    window.addEventListener('load', () => {
        setTimeout(() => {
            timerFinished = true;
            showModal();
        }, time);
    }, false);

    let scrollTimeout;

    // Listen for scroll events to check if the subscription boxes are in view
    window.addEventListener('scroll', () => {
        if (scrollTimeout) clearTimeout(scrollTimeout);

        scrollTimeout = setTimeout(() => {
            showModal();
        }, 200); // run 200ms after scroll stops
    });
}

function modalPdAutoOpen(element, ani) {
    if ($(element).length === 0) {
        return;
    }

    const $daysLeft = $(element).find('#daysLeft');

    if ($daysLeft.length && parseInt($daysLeft.val(), 10) === 0) {
        return;
    }

    if (!window.sessionStorage.getItem('winPdModalSeen')) {
        window.sessionStorage.setItem('winPdModalSeen', 'no');
    }

    const defaulTimer = 30; // default seconds if input is left empty
    const timeInput = $('#modalPdTime').val();
    let timerFinished = false;
    let time;
    if (isNaN(timeInput)) {
        time = defaulTimer * 1000;
    } else {
        time = parseInt($('#modalPdTime').val(), 10) * 1000;
    }

    function showModal() {
        const winPdModalSeen = window.sessionStorage.getItem('winPdModalSeen');

        if (timerFinished === true && winPdModalSeen === 'no') {
            // open modal
            modalTrigger(element, 'open', ani);

            // Make modal focusable
            (element).removeAttr('inert');

            // set session
            $('.modal-close').on('click', () => {
                modalTrigger(element, 'close', 'up-down');
                window.sessionStorage.setItem('winPdModalSeen', 'yes');
            });

            $('.modal-backdrop').on('click', () => {
                modalTrigger(element, 'close', 'up-down');
                window.sessionStorage.setItem('winPdModalSeen', 'yes');
            });
        }
    }

    window.addEventListener('load', () => {
        setTimeout(() => {
            timerFinished = true;
            showModal();
        }, time);
    }, false);
}

/**
 * Closes a given modal with accessibility features
 * @param {jQuery} $modal - The jQuery object of the modal to close
 * @param {Object} [options] - Optional parameters
 * @param {string} [options.animation='up-down'] - Animation type
 * @param {string} [options.overlayClass] - Optional overlay class
 * @param {Function} [options.onClose] - Callback after modal closes (e.g. cleanup)
 * @param {jQuery} [options.restoreFocusTo] - Element to return focus to
 * @param {Function} [options.restoreFocusFn] - Custom function to call for restoring focus
 */
function modalClose($modal, {
    animation = 'up-down',
    overlayClass = '',
    onClose = null,
    restoreFocusTo = null,
    restoreFocusFn = null,
} = {}) {
    if (!$modal || !$modal.length) return;

    modalTrigger($modal, 'close', animation, overlayClass);
    $modal.attr('inert', '');
    removeModalFocus($modal);

    if (typeof onClose === 'function') {
        onClose();
    }

    // Restore focus (custom, specific element, or fallback)
    setTimeout(() => {
        if (typeof restoreFocusFn === 'function') {
            restoreFocusFn($modal);
        } else if (restoreFocusTo && restoreFocusTo.length) {
            restoreFocusTo.trigger('focus');
        } else {
            restoreFocus();
        }
    }, 100);
}

export {
    modalTrigger,
    modalAutoOpen,
    modalPdAutoOpen,
    modalClose,
};
